var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducationMini = function SvgEducationMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    stroke: "#939393",
    strokeWidth: 0.4,
    d: "M22.587 8.58 12.273 4.056a.682.682 0 0 0-.546 0L1.413 8.58c-.55.242-.55 1.035 0 1.277l3.712 1.627v4.343C5.125 18.166 8.145 20 12 20s6.875-1.833 6.875-4.174v-4.343l.688-.302v7.428c0 .384.308.695.688.695a.69.69 0 0 0 .687-.695v-8.03l1.649-.723c.55-.242.55-1.035 0-1.277zM12 5.453l8.584 3.763-.68.299-7.819-.989a.69.69 0 0 0-.767.604.695.695 0 0 0 .597.777l5.506.696L12 12.981 3.416 9.217 12 5.454zm5.5 10.372c0 .656-.531 1.33-1.458 1.851-2.208 1.242-5.87 1.245-8.084 0-.927-.52-1.458-1.195-1.458-1.85v-3.741l5.227 2.291a.674.674 0 0 0 .546 0l5.227-2.291v3.74z"
  })));
};
export default SvgEducationMini;